import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-1041",
  "use": "icon-1041-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" class=\"qi-1041\" viewBox=\"0 0 16 16\" id=\"icon-1041\">\n  <path d=\"M12.615 3.946c-1.958.576-2.509 2.23-2.383 3.268C8.835 5.52 8.734 3.567 8.893.764c-4.48 1.743-3.438 6.767-3.572 8.293-1.127-.951-1.34-3.225-1.34-3.225-1.19.631-1.786 2.318-1.786 3.686 0 3.308 2.667 5.719 5.872 5.719s5.737-2.412 5.737-5.719c.001-1.967-1.354-2.617-1.189-5.572z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol